import { render, staticRenderFns } from "./CreatorMetricsDrawer.vue?vue&type=template&id=5bb17512&scoped=true"
import script from "./CreatorMetricsDrawer.vue?vue&type=script&lang=js"
export * from "./CreatorMetricsDrawer.vue?vue&type=script&lang=js"
import style0 from "./CreatorMetricsDrawer.vue?vue&type=style&index=0&id=5bb17512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb17512",
  null
  
)

export default component.exports